module.exports = __webpack_public_path__ + "static/img/manage-bg.1884695.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manage-bg.png
// module id = w6X2
// module chunks = 0